import { initApp } from '@/bootstrap';

initApp()
  .catch((e) => {
    console.error(e);
    console.error('app failed initialization');
  });
